import { InputBaseComponentProps, SxProps, TextField, Theme, useTheme } from '@mui/material';
import { FC, FocusEventHandler, KeyboardEventHandler, WheelEventHandler } from 'react';

interface Props {
  className?: string;
  inputRef?: any;
  variant?: 'standard' | 'filled' | 'outlined';
  required?: boolean;
  sx?: SxProps<Theme>;
  id?: string;
  type?: React.InputHTMLAttributes<unknown>['type'];
  name?: string;
  label?: React.ReactNode;
  //Inputs that always paint something (colour, date) need the label kept up, or it sits over the value.
  shrinkLabel?: boolean;
  value?: unknown;
  defaultValue?: unknown;
  error?: boolean;
  helperText?: React.ReactNode;
  htmlInputProps?: InputBaseComponentProps;
  endAdornment?: React.ReactNode;
  multiline?: boolean;
  disabled?: boolean;
  rows?: number;
  fullWidth?: boolean;
  autoFocus?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onKeyDown?: KeyboardEventHandler<HTMLDivElement>;
  onWheel?: WheelEventHandler<HTMLDivElement>;
}

export const QcsTextField: FC<Props> = ({
  className,
  inputRef,
  variant,
  required,
  sx,
  id,
  type,
  name,
  label,
  shrinkLabel,
  value,
  defaultValue,
  error,
  helperText,
  htmlInputProps,
  endAdornment,
  multiline,
  disabled,
  rows,
  fullWidth,
  autoFocus,
  onChange,
  onBlur,
  onKeyDown,
  onWheel,
}) => {
  const theme = useTheme();

  return (
    <TextField
      className={className}
      inputRef={inputRef}
      variant={variant}
      id={id}
      type={type}
      name={name}
      //Dont use required parameter.
      label={required ? <>{label} *</> : label}
      value={value}
      defaultValue={defaultValue}
      error={error}
      helperText={helperText}
      slotProps={{ htmlInput: htmlInputProps, input: { endAdornment }, ...(shrinkLabel && { inputLabel: { shrink: true } }) }}
      multiline={multiline}
      rows={rows}
      disabled={disabled}
      fullWidth={fullWidth}
      sx={{
        '& .MuiInputBase-root': {
          backgroundColor: theme.palette.common.white,
        },
        '& .MuiFormHelperText-root': {
          backgroundColor: 'rgba(245,246,250,0)',
          marginLeft: 0,
          marginRight: 0,
        },
        ...sx,
      }}
      autoFocus={autoFocus}
      onChange={onChange}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onWheel={onWheel}
    />
  );
};
